/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiShareAExportIcon20Solid = forwardRef('ArrowUiShareAExportIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.607 1.793a1 1 0 1 0-1.414 1.414l1.794 1.794H12V3a1 1 0 0 0-1-1H5a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-1a1 1 0 0 0-1-1h-1.5A2.5 2.5 0 0 1 12 9.5V7.001h4.987l-1.794 1.794a1 1 0 0 0 1.414 1.415l2.794-2.795a2 2 0 0 0 0-2.828l-2.794-2.794ZM12 7v-2h-1.5a5.5 5.5 0 0 0-5.5 5.5V11a1 1 0 1 0 2 0v-.498a3.5 3.5 0 0 1 3.5-3.5H12Z" })));
});
